/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import FormValidation from '../../atoms/formEnums/formValidation';
import InputText from '../../atoms/inputText/inputText';
import InputTag from '../../atoms/inputTag/inputTag';
import Label from '../../atoms/label/label';
import { IconType } from '../../atoms/icon/icon';
import { ButtonTheme } from '../../atoms/button/button';
import './formLink.scss';
import LoadFromCatalogButton from '../../molecules/loadFromCatalogButton/loadFromCatalogButton';
import { unset } from 'lodash';
import ExternalLink from '../../atoms/externalLink/externalLink';


/**
 * Form Input Text is a basic HTML input field, label, error text and HelpButton.
 * It is designed to send the input value to a parent component, such as organisms Form,
 * and to shows the validation state of the field provided by the parent component.
 */
const FormLink = (props) => {
  const {
    id,
    label,
    placeholder,
    helpText,
    onChange,
    defaultValue,
    disabled,
    hidden,
    iconSize,
    textNoLink,
    to,
    icon,
    value,
    customIcon,
    iconColor,
    target,
    postUrl,
    swalTitle,
    swalText,
    hasClick,
    className,

  } = props;

  const childRef = useRef();
  return (
    <div className={`form-group row ${className} ${(hidden?"form-input-text__hidden":"")}`}>
      { label !== ''
        && (
          <Label helpText={helpText}>{label}</Label>
        )}
      <div className="col-sm-8">
        {to && <ExternalLink
          id={id}
          icon={icon}
          to={to}
          iconSize={iconSize}
          target={target}
          iconColor={iconColor}
          hasClick={hasClick}
        />}
        {!to && !hasClick && 
        <ExternalLink
          id={id}
          icon={icon}
          to={to}
          iconSize={iconSize}
          target={target}
          iconColor={iconColor}
          hasClick={hasClick}
        />}
        {!to && textNoLink && 
          <div>{textNoLink}</div>
        }
        {value && <span className="form-link_name">{value}</span>}
      </div>
    </div>
  );
};

FormLink.propTypes = {
  /**
   * id of input field
   */
  id: PropTypes.string,
  /**
   * Defined text errors
   */
  errorText: PropTypes.string,
  /**
   * Name of input attribute
   */
  label: PropTypes.string,
  /**
   * Placeholder inside the HTML input
   */
  placeholder: PropTypes.string,
  /**
   * Input help text
   */
  helpText: PropTypes.string,
  /**
   * Initial input value
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Function to bind onChange HTML functionality
   */
  onChange: PropTypes.func,
  /**
   * Default value
   */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
};

FormLink.defaultProps = {
  id: '',
  errorText: '',
  label: '',
  placeholder: '',
  helpText: '',
  value: '',
  onChange: () => {},
  defaultValue: '',
  className: ''
};

export default FormLink;
